import { render, staticRenderFns } from "./CertificateOverview.vue?vue&type=template&id=3c71d8f8&scoped=true"
import script from "./CertificateOverview.vue?vue&type=script&lang=js"
export * from "./CertificateOverview.vue?vue&type=script&lang=js"
import style0 from "./CertificateOverview.vue?vue&type=style&index=0&id=3c71d8f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c71d8f8",
  null
  
)

export default component.exports